import { Box, Cover, Disclosure, DisclosureContent, DisclosureTrigger } from '@optiaxiom/react';
import { Pill } from '@optiaxiom/react/unstable';

import { MarkdownText } from '@frontend/components/MarkdownText';
import { TruncatedList } from '@frontend/components/ui';

type VariablesProps = {
  data: Record<string, unknown>;
};

const formatJsonForMarkdown = (data: Record<string, unknown>): string => {
  return '```json\n' + JSON.stringify(data, null, 2) + '\n```';
};

const truncate = (str: string, maxLength: number = 30) =>
  str.length > maxLength ? str.slice(0, maxLength) + '...' : str;
const formatValue = (value: unknown): string => {
  if (value === null) return 'null';
  if (value === undefined) return 'undefined';
  if (typeof value === 'object') return '<object>';
  if (typeof value === 'string') return truncate(value);
  return truncate(String(value));
};

export function Variables({ data }: VariablesProps) {
  const jsonMarkdown = formatJsonForMarkdown(data);
  const propertyNames = Object.keys(data).sort((a, b) => a.localeCompare(b));
  const hasContent = propertyNames.length > 0;

  if (!hasContent) {
    return null;
  }

  return (
    <Disclosure>
      <DisclosureTrigger py="0" onClick={e => e.stopPropagation()}>
        <Cover asChild>
          <TruncatedList lineClamp={1} gap="4">
            {propertyNames.map(name => (
              <Pill key={name} color="fg.tertiary" size="sm">
                {name}:{' '}
                <Box asChild color="fg.default">
                  <span>{formatValue(data[name])}</span>
                </Box>
              </Pill>
            ))}
          </TruncatedList>
        </Cover>
      </DisclosureTrigger>
      <DisclosureContent>
        <MarkdownText text={jsonMarkdown} />
      </DisclosureContent>
    </Disclosure>
  );
}
